import { Routes } from '@angular/router';

export const SAMPLEGROUP_ROUTES: Routes = [
  {
    path: 'channels/sample-groups/view-edit/:sampleGroupId',
    loadComponent: () =>
      import('./sample-group-view-edit/sample-group-view-edit.component').then(
        (com) => com.SampleGroupViewEditComponent
      ),
    title: 'View/Edit Service Types',
  },
  {
    path: 'channels/sample-groups/add',
    loadComponent: () =>
      import('./sample-group-add/sample-group-add.component').then(
        (com) => com.SampleGroupAddComponent
      ),
    title: 'Add Service Type',
  },
];
